export const sumCountFromData = (data: { value: number }[]) => {
  let sum = 0;

  data.forEach((row) => {
    sum += row.value;
  });
  return sum;
};
